(function () {
  class ChampagneModifier extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;
      gameData.champagneModifier = this;
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
      messageBus.subscribe('game:champagneModifier', (event) => {
        this.onChampagneModifier(event);
      });
    }

    onLayoutComplete() {
      this.baseName = this.name + ':';
      this.grabReferences();
      this.setupSpineAnims();
      this.setupParticles();
    }

    grabReferences() {
      this.gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');
      this.champersReelAnimContainer = resourceManager.get(`slotContainer:champagneContainer`);
      this.champersReelAnimContainer.visible = false;

      this.champersReelAnims = [];
      for (let i = 0; i < 5; i++) {
        this.champersReelAnims[i] = resourceManager.get(`slotContainer:champagneContainer:champagneReel${i}`);
        this.champersReelAnims[i].visible = false;
      }
    }

    setupSpineAnims() {
      this.catAnim = resourceManager.createObject('spine', 'champers_cat', this.baseName + 'catAnimContainer', {
        name: 'champers_cat',
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      });
      this.catAnim.visible = false;
    }

    setupParticles() {
      this.particleEffect = particleManager.createEmitter(
        'champers_sparks_emitter',
        this.baseName + 'particleContainer',
        0,
        0,
        false
      );
      this.particleEffect.particleEmitter.emit = false; // don't show particles
    }

    async onChampagneModifier(event) {
      event.join();

      await this.doModifier(event);

      event.leave();
    }

    async doModifier(event) {
      const originalReelIndex = event.data.modifierData.reelUpgraded;
      const adjustedReelIndex = Utils.reelIndexToGigaReelIndex(originalReelIndex, event.data.blockDistribution);
      const symbolID = event.data.modifierData.symbol;

      this.visible = true;

      soundManager.play('champagne');

      await this.catEnters();

      this.catShakesBottle();

      await timerManager.delayAsync(900);

      this.particleEffect.particleEmitter.emit = true;

      await timerManager.delayAsync(150);

      this.champersReelAnimContainer.visible = true;
      const champersReelAnimPromise = Utils.playMovieAsync(this.champersReelAnims[originalReelIndex]);

      Utils.tweenFromToAsync(
        this.catAnim,
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: 0.25,
        }
      );

      await timerManager.delayAsync(500);

      // when movie has covered the reels
      // swap out the symbols underneath

      const reels = this.gigabloxFactory.getReelVisuals();
      const reelObject = reels[adjustedReelIndex]; //reelManager.reels[reelToUpgrade];
      for (let i = 0; i < 5; i++) {
        reelObject.setReelSymbol(i, symbolID);
      }

      await timerManager.delayAsync(150);
      const symbolScalePromise = this.scaleAllSymbols(reelObject);

      await champersReelAnimPromise;
      this.champersReelAnimContainer.visible = false;

      await symbolScalePromise;

      this.visible = false;

      this.particleEffect.particleEmitter.emit = false;
      this.catAnim.alpha = 1;
      this.catAnim.visible = false;
    }

    async catEnters() {
      await Utils.playSpineAsync('Entry', this.catAnim, false);
    }

    async catShakesBottle() {
      await Utils.playSpineAsync('Active', this.catAnim, false);
    }

    async scaleAllSymbols(reelObject) {
      reelObject.suspendUpdates(); // stop the reels controlling the positions etc

      const promises = [];

      // starting from the top
      const symbols = reelObject.getSymbolGfx();
      for (let i = 0; i < 5; i++) {
        // const symbolSprite = reelObject.symbolSprites[i + reelObject.Props.preappertureSymbols];
        const symbolSprite = symbols[i].symbol;
        symbolSprite.anchor.set(0.5, 0.5);
        symbolSprite.x += symbolSprite.width / 2;
        symbolSprite.y += symbolSprite.height / 2;
        promises[i] = Utils.tweenFromToAsync(
          symbolSprite.scale,
          {
            x: 1,
            y: 1,
          },
          {
            x: 0.85,
            y: 0.85,
            duration: 0.1,
            yoyo: true,
            repeat: 1,
          }
        );
        await timerManager.delayAsync(65);
      }

      await Promise.all(promises);

      for (let i = 0; i < 5; i++) {
        const symbolSprite = symbols[i].symbol;
        symbolSprite.anchor.set(0, 0);
        symbolSprite.x -= symbolSprite.width / 2;
        symbolSprite.y -= symbolSprite.height / 2;
      }

      reelObject.clearSuspendUpdates();
    }
  }

  //////////////////////////////////////////////////
  create = function (json) {
    return new ChampagneModifier();
  };

  //////////////////////////////////////////////////
  initialise = function (json, container, resources) {
    container.initialise();
  };

  //////////////////////////////////////////////////
  getFilesRequired = function (json) {
    return ['', ''];
  };

  resourceManager.registerObjectType('ChampagneModifier', create, initialise, getFilesRequired);
})();
